import React from 'react';
import type { SvgIconComponent } from '@mui/icons-material';
import {
  Biotech as ExamIcon,
  CardGiftcard as CourtesyIcon,
  EventBusy as CommitmentIcon,
  EventRepeat as ReturnIcon,
  LocalHospital as SurgeryIcon,
  MedicalServices as MedicalIcon,
  SelfImprovement as PilatesIcon,
  Vaccines as ProcedureIcon,
  WarningAmber as EmergencyIcon,
} from '@mui/icons-material';

export const APPOINTMENT_TYPE_ICON_OPTIONS: { id: string; label: string; Icon: SvgIconComponent }[] = [
  { id: 'consultation', label: 'Consulta', Icon: MedicalIcon },
  { id: 'procedure', label: 'Procedimento', Icon: ProcedureIcon },
  { id: 'return', label: 'Retorno', Icon: ReturnIcon },
  { id: 'exam', label: 'Exame', Icon: ExamIcon },
  { id: 'emergency', label: 'Emergência', Icon: EmergencyIcon },
  { id: 'surgery', label: 'Cirurgia', Icon: SurgeryIcon },
  { id: 'courtesy', label: 'Cortesia', Icon: CourtesyIcon },
  { id: 'commitment', label: 'Compromisso', Icon: CommitmentIcon },
  { id: 'pilates', label: 'Atividade', Icon: PilatesIcon },
  { id: 'medical', label: 'Geral', Icon: MedicalIcon },
];

const ICON_BY_ID: Record<string, SvgIconComponent> = Object.fromEntries(
  APPOINTMENT_TYPE_ICON_OPTIONS.map((o) => [o.id, o.Icon]),
);

/** Ícone padrão por chave interna do tipo (consultation, pilates, …). */
export const DEFAULT_TYPE_KEY_ICON: Record<string, string> = {
  consultation: 'consultation',
  procedure: 'procedure',
  return: 'return',
  exam: 'exam',
  emergency: 'emergency',
  surgery: 'surgery',
  courtesy: 'courtesy',
  commitment: 'commitment',
  pilates: 'pilates',
  rpg: 'pilates',
  reabilitacao: 'pilates',
  lpf: 'pilates',
  lpf_pilates: 'pilates',
  estetica: 'procedure',
  avaliacao: 'exam',
  reavaliacao: 'return',
  limpeza_de_pele: 'procedure',
  pilates_personal: 'pilates',
};

export function resolveAppointmentTypeIconComponent(
  typeKey: string,
  iconId?: string | null,
): SvgIconComponent {
  const explicit = String(iconId || '').trim().toLowerCase();
  if (explicit && ICON_BY_ID[explicit]) return ICON_BY_ID[explicit];
  const fromKey = DEFAULT_TYPE_KEY_ICON[String(typeKey || '').trim().toLowerCase()];
  if (fromKey && ICON_BY_ID[fromKey]) return ICON_BY_ID[fromKey];
  return MedicalIcon;
}

export function renderAppointmentTypeIconNode(
  typeKey: string,
  color: string,
  fontSize = 18,
  iconId?: string | null,
): React.ReactElement {
  const Icon = resolveAppointmentTypeIconComponent(typeKey, iconId);
  return <Icon sx={{ fontSize, color, flexShrink: 0 }} />;
}
